






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CargaDestinatario} from '@/model/resource/CargaDestinatario'
import {InputCargaDestinatarioSchema} from '@/schema/resource/CargaDestinatario/InputCargaDestinatarioSchema'

@Component
export default class PersistCargaDestinatarioView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaDestinatarioSchema()
  cargaDestinatario = new CargaDestinatario()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
    this.schema.collectionEndereco.listEndereco()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.cargaDestinatario.getCargaDestinatario(id)
    }

    $.await.done('getCargaDestinatario')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.cargaDestinatario.persistCargaDestinatario()
    await Helper.successAndPush(
      'system.success.persist',
      '/carga-destinatario/list'
    )
  }
}
